var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 6C18.5523 6 19 6.44772 19 7V20C19 20.5523 18.5523 21 18 21H8C7.44772 21 7 20.5523 7 20V7C7 6.44772 7.44772 6 8 6H18ZM9 19H17V8H9V19ZM14.5 2C15.0523 2 15.5 2.44772 15.5 3C15.5 3.55228 15.0523 4 14.5 4H6C5.44772 4 5 4.44772 5 5V16.5C5 17.0523 4.55228 17.5 4 17.5C3.44772 17.5 3 17.0523 3 16.5V5C3 3.34315 4.34315 2 6 2H14.5Z"
  })));
};
export default SvgCopy;